import { DATA, KEY, NumberSchema, OPTIONAL_KEY, REQUIRED_STRING, Resource } from "shelving";
import { GROUP_FORM_SCHEMA, MEMBER_SCHEMA, MESSAGE_FORM_SCHEMA } from "shared/schema";

const MEMBER_VALIDATOR = DATA({ gid: KEY, uid: KEY });

export const CREATE_GROUP = new Resource("createGroup", GROUP_FORM_SCHEMA, REQUIRED_STRING);
export const EDIT_GROUP = new Resource("editGroup", DATA({ gid: KEY, ...GROUP_FORM_SCHEMA.props }));
export const JOIN_GROUP = new Resource("joinGroup", KEY);
export const LEAVE_GROUP = new Resource("leaveGroup", KEY);
export const DELETE_GROUP = new Resource("deleteGroup", KEY);
export const INVITE_MEMBER = new Resource("inviteMember", MEMBER_VALIDATOR);
export const APPROVE_MEMBER = new Resource("approveMember", MEMBER_VALIDATOR);
export const MUTE_MEMBER = new Resource(
	"muteMember",
	DATA({
		gid: KEY,
		uid: KEY,
		days: new NumberSchema({ min: 1, max: 365 }),
		why: MEMBER_SCHEMA.props.why,
	}),
);
export const UNMUTE_MEMBER = new Resource("unmuteMember", MEMBER_VALIDATOR);
export const BLOCK_MEMBER = new Resource(
	"blockMember",
	DATA({
		gid: KEY,
		uid: KEY,
		why: MEMBER_SCHEMA.props.why,
	}),
);
export const REMOVE_MEMBER = new Resource("removeMember", MEMBER_VALIDATOR);
export const PROMOTE_MEMBER = new Resource("promoteMember", MEMBER_VALIDATOR);
export const DEMOTE_MEMBER = new Resource("demoteMember", MEMBER_VALIDATOR);

export const CREATE_MESSAGE = new Resource(
	"createMessage",
	DATA({
		gid: KEY,
		thread: OPTIONAL_KEY,
		...MESSAGE_FORM_SCHEMA.props,
	}),
	REQUIRED_STRING,
);

export const DELETE_MESSAGE = new Resource("deleteMessage", KEY);
